import React, { useState } from 'react'
import { connect } from 'react-redux'
import clsx from 'clsx'

import Event from './event/QuickLook'
import CreateEventModal from './CreateEventModal'
import CreatedEventModal from './wizard/CreatedEventModal.js'
import Loader from '../../common/components/notifications/Loader'
import queryString from 'query-string'
import RestrictedComponent from '../../lib/components/form/RestrictedComponent'
import { EVENT_VIEW_TYPES } from '../../redux/events/reducers'
import moment from 'moment'
import TableView from './event/TableView'
import CalendarView from './event/CalendarView'
import { useSetTab } from './event/ActiveEvent'
import schema from '../../routes/permissions/schema'
import { Box } from "@mui/material"

const Events = (props) => {
  const [showCreateModal, setShowCreateModal] = useState(false)
  const [showCreatedModal, setShowCreatedModal] = useState(false)
  const [showCreatingOverlay, setShowCreatingOverlay] = useState(false)
  const toggleCreateEventModal = () => setShowCreateModal(!showCreateModal)

  /**
   *
   * @param {Object[]} events array of event data objects
   * @returns {string[]} sorted list of event IDs
   */
  const getSortedEventIds = (events) => {
    return sortEvents(Object.values(events)).map((event) => event.eventID)
  }

  const sortEvents = (events) => {
    if (events.length <= 1) {
      return events
    }
    function sortByDateAscending(a, b) {
      var aDate = new Date(a.startDateTime.replace(/-/g, '/'))
      var bDate = new Date(b.startDateTime.replace(/-/g, '/'))
      if (aDate < bDate) return -1
      if (aDate > bDate) return 1
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    }

    function sortByDateDescending(a, b) {
      var aDate = new Date(a.startDateTime.replace(/-/g, '/'))
      var bDate = new Date(b.startDateTime.replace(/-/g, '/'))
      if (aDate > bDate) return -1
      if (aDate < bDate) return 1
      if (a.title < b.title) return -1
      if (a.title > b.title) return 1
      return 0
    }

    return props.filters.sortBy === 'ASC'
      ? events.sort(sortByDateAscending)
      : events.sort(sortByDateDescending)
  }

  const handleSortChange = (event) => {
    event.preventDefault()
    props.onFilterChange({
      type: 'change',
      params: {
        sortBy: props.filters.sortBy === 'ASC' ? 'DESC' : 'ASC',
      },
    })
  }

  const spliceBadSourceFromStreams = (eventID) => {
    console.warn('spliceBadSourceFromStreams: %s', eventID)
  }


    // display the create(d) event modals
    const createEventModal = () => {
      const modals = [
        <CreateEventModal
          key='event create modal'
          showCreatedModal={() => {
            setShowCreateModal(false)
            setShowCreatedModal(true)
          }}
          showOverlay={() => {
            setShowCreatingOverlay(true)
          }}
          hideModals={() => {
            setShowCreateModal(false)
            setShowCreatedModal(false)
            setShowCreatingOverlay(false)
          }}
          toggleCreateEventModal={toggleCreateEventModal}
          encoders={props.encoders}
          actions={props.actions}
          timeZone={props.timeZone}
          visible={showCreateModal}
        />,
        <div key="event creation overlay">
          {showCreatingOverlay ? (
            <div
              key='show create overlay'
              style={{
                position: 'absolute',
                overflow: 'hidden',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                // cover full height of page or events container whichever is more
                height: '100vh',
                minHeight: '100%',
                backgroundColor: 'rgba(0,0,0,0.7)',
                zIndex: 101,
              }}
            >
              <div style={{ position: 'fixed', width: '100%', top: '10%' }}>
                <Loader message='Creating Event' />
              </div>
            </div>
          ) : null}
          <CreatedEventModal
            key='created event modal'
            hideOverlay={() => setShowCreatingOverlay(false)}
            mode='route-listing'
            visible={showCreatedModal}
            showCreateModal={() => {
              setShowCreateModal(true)
              setShowCreatingOverlay(true)
              setShowCreatedModal(false)
            }}
          />
        </div>,
      ]
      return modals
    }

  const render = (tab, setTab) => {
    return props.loading ||
      props.eventViewType.key === EVENT_VIEW_TYPES.CALENDAR.key ||
      props.eventViewType.key === EVENT_VIEW_TYPES.TABLE.key ||
      Object.keys(props.events).length ? (
      renderEvents(props.events, tab, setTab)
    ) : (
      <div className='alert alert-warning'>
        {createEventModal()}
        <h4>No events found for this search:</h4>
        {printQuery()}
        <RestrictedComponent permissionCheck={schema.EVENT.CREATE}>
          <button
            type='button'
            className='btn btn-success'
            style={{marginRight: '1rem', marginTop: '1em'}}
            onClick={ev => {
              toggleCreateEventModal(ev)
            }}
          >
            <i className='fa fa-plus' style={{ paddingRight: '1rem' }} />
            Create Event
          </button>
        </RestrictedComponent>
      </div>
    )
  }

  const renderEvents = (events, tab, setTab) => {
    const sortedEventIds = getSortedEventIds(events)
    const getEventProps = (eventID) => ({
      ...props,
      ajaxState: props.eventAjaxState[eventID], //@TODO: refactor ajax state to be some pending
      toggleActiveEvent: props.toggleActiveEvent,
      spliceBadSourceFromStreams: spliceBadSourceFromStreams.bind(
        null,
        eventID
      ),
      event: events[eventID],
      chat: props.chat,
      clock: props.clock,
      encoderActions: props.encoderActions,
      encoders: props.encoders,
      actions: props.actions.events,
      chatActions: props.chatActions,
      requests: props.requests,
      eventViewType: props.eventViewType,
    })
    const eventReplacementViews = [
      EVENT_VIEW_TYPES.SLIM.key,
      EVENT_VIEW_TYPES.GRID.key,
      EVENT_VIEW_TYPES.EXPANDED.key,
    ]

    if (
      props.loading &&
      props.eventViewType.key !== EVENT_VIEW_TYPES.CALENDAR.key &&
      props.eventViewType.key !== EVENT_VIEW_TYPES.TABLE.key
    ) {
      return <Loader />
    }

    return (
      <div className='clearfix' key={`rendered events ${tab}`}>
        {createEventModal(showCreateModal)}
        {props.eventViewType.key !== EVENT_VIEW_TYPES.CALENDAR.key ? (
            <Box sx={{margin: "0 0 2rem", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap" }}>
                <RestrictedComponent
                 permissionCheck={`${schema.EVENT.READ},${schema.EVENT.CREATE}`}
                >
                <button
                    type='button'
                    className='btn btn-success'
                    style={{ marginRight: '1rem' }}
                    disabled={props.loading}
                    onClick={toggleCreateEventModal}
                >
                    <i className='fa fa-plus' style={{ paddingRight: '1rem' }} />
                    Create Event
                </button>
                </RestrictedComponent>

                <Box sx={{display:"flex", alignItems: "baseline"}}>
                    {
                        moment(props.filters.startDateTime).format('MM-DD-YY') === moment(props.filters.stopDateTime).format('MM-DD-YY') ?
                        `Selected Date:
                        ${moment(props.filters.startDateTime).format('MM-DD-YY')}` :
                        `Selected Date Range:
                        ${moment(props.filters.startDateTime).format('MM-DD-YY')} to
                        ${moment(props.filters.stopDateTime).format('MM-DD-YY')}`
                    }

                    <button
                    type='button'
                    className='btn btn-light'
                    onClick={handleSortChange}
                    style={{ float: 'right', marginLeft: "1em" }}
                    >
                    {props.filters.sortBy === 'ASC' ? (
                        <i className='fas fa-sort-amount-down fa-1x'></i>
                        ) : (
                            <i className='fas fa-sort-amount-up fa-1x'></i>
                            )}{' '}
                    Sort Date
                    </button>
                </Box>

            </Box>
        ) : null}
        {eventReplacementViews.includes(props.eventViewType.key) ? (
          <div
            className={clsx(
              'events-list',
              props.eventViewType.key === EVENT_VIEW_TYPES.SLIM.key && 'slim',
              props.eventViewType.key === EVENT_VIEW_TYPES.GRID.key && 'grid'
            )}
          >
            {sortedEventIds.map(function (eventID) {
              return (
                <div
                  key={'event-' + eventID}
                  className={clsx(
                    'event',
                    props.eventViewType.key === EVENT_VIEW_TYPES.SLIM.key &&
                      'slim',
                    props.eventViewType.key === EVENT_VIEW_TYPES.GRID.key &&
                      'grid'
                  )}
                >
                  <Event
                    {...getEventProps(eventID)}
                    tab={tab}
                    setTab={setTab}
                    key={`event-${eventID}`}
                  />
                </div>
              )
            }, this)}
          </div>
        ) : props.eventViewType.key === EVENT_VIEW_TYPES.TABLE.key ? (
          <TableView
            events={events}
            toggleActiveEvent={props.toggleActiveEvent}
            actions={props.actions.events}
          />
        ) : (
          <div style={{ overflow: 'auto' }}>
            <div
              style={{
                backgroundColor: 'white',
                borderRadius: '10px',
                padding: '1em',
                minWidth: '50em',
              }}
            >
              <CalendarView
                loading={props.loading}
                onFilterChange={props.onFilterChange}
                events={events}
                toggleActiveEvent={props.toggleActiveEvent} //open quicklook
                actions={props.actions.events} //event pause start break stop
              />
            </div>
          </div>
        )}
      </div>
    )
  }

  /*
        Show all the applied filters if no Events are retured from the API
        with the active query.
        */
  const printQuery = () => {
    var list = []
    if (props && !props.filters.eventID) {
      var searchByID = props.filters.eventID || props.filters.customID
      if (!searchByID) {
        list.push({
          'Start Date': moment(props.filters.startDateTime).format(
            'MM/DD/YYYY'
          ),
        })
        list.push({
          'End Date': moment(props.filters.stopDateTime).format('MM/DD/YYYY'),
        })
      }
      if (props.filters.liveOnly) {
        list.push({ 'List Only Live Events': true })
      }
      if (props.filters.getOnlyPrivate) {
        list.push({ 'List Only Private Events': true })
      }
    } else if (props) {
      list.push({ 'Event ID': props.filters.eventID })
    } else {
      const parsed = queryString.parse(location.search)
      if (parsed && parsed.eventID) list.push({ 'Event ID': parsed.eventID })
    }

    // render search params
    if (props && Object.keys(props.filters).length) {
      var mapTerms = {
        eventID: 'Event ID',
        customID: 'Custom ID',
        anyCategories: 'Categories',
      }
      var key = Object.keys(props.filters)[0]
      var elmt = {}
      var displayName =
        mapTerms[key] || key.charAt(0).toUpperCase() + key.slice(1)
      if (displayName !=='StartDateTime') {
        elmt[displayName] = props.filters[key]
        if (key !== 'anyCategories' || props.filters.anyCategories.length) {
          list.push(elmt)
        }
      }
    }

    return (
      <ul>
        {list.map(function (item, index) {
          var name = Object.keys(item)
          return (
            <li key={'not-found-query-param-' + index}>
              <em>{name}:</em> <strong>{item[name].toString()}</strong>
            </li>
          )
        })}
      </ul>
    )
  }

  const [tab,setTab] = useSetTab()
  return render(tab, setTab)
}

const mapStateToProps = (state) => {
  const eventViewType = state.events.viewType
  const filters = state.events.filters
  const user = state.data.user
  return { eventViewType, filters, user }
}

export default connect(mapStateToProps)(Events)
